/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-07-19 11:16:07
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-08-28 16:24:20
 * @FilePath: \地质云前端\src\utils\watermark.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
let watermark = {}
// 页面设置水印
let setWatermark = (text, sourceBody) => {
  let id = Math.random()*10000+'-'+Math.random()*10000+'/'+Math.random()*10000

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }

  let can = document.createElement('canvas');
  can.width = 150;
  can.height = 120;

  let cans = can.getContext('2d');
  cans.rotate(-20 * Math.PI / 180);
  cans.font = '15px Vedana';
  cans.fillStyle = 'rgba(0, 0, 0, .5)';
  cans.textAlign = 'left';
  cans.textBaseline = 'Middle';
  cans.fillText(text, can.width / 20, can.height );

  let water_div = document.createElement('div');
  water_div.id = id;
  water_div.style.pointerEvents = 'none';
  water_div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat';
  if(sourceBody){
    water_div.style.width = '100%';
    water_div.style.height = '100%';
    sourceBody.appendChild(water_div);
  }else{
    water_div.style.top = '3px';
    water_div.style.left = '0px';
    water_div.style.position = 'fixed';
    water_div.style.zIndex = '100000';
    water_div.style.width = document.documentElement.clientWidth  + 'px';
    water_div.style.height = document.documentElement.clientHeight  + 'px';
    document.body.appendChild(water_div);
  }

  return id;
}

/**
 *  该方法只允许调用一次
 *  @param:
 *  @text == 水印内容
 *  @sourceBody == 水印添加在哪里，不传就是body
 * */
watermark.set = (text, sourceBody) => {
  let id = setWatermark(text, sourceBody)
  setInterval(() => {
    if (document.getElementById(id) === null) {
      id = setWatermark(text, sourceBody)
    }
  }, 2000)
  window.onresize = () => {
    setWatermark(text, sourceBody)
  }
}


// 图片--增加水印
function downloadImage(url, title) {
  const imageUrl = url; // 替换为实际图片 URL
  // const watermarkText = "煤炭地质云";
  const watermarkText = "www.coalgeocloud.com";

  // 创建一个新的 Image 对象
  const img = new Image();
  img.setAttribute("crossOrigin", "anonymous");
  // img.crossOrigin = 'Anonymous'; // 允许跨域访问

   // 图片加载完成后执行
   img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);

    // 添加水印文本
    ctx.font = '24px Arial';
    ctx.fillStyle = 'rgba(51, 51, 51, 0.3)'; // 设置水印文本颜色和透明度
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
    ctx.rotate(-20 * Math.PI / 180);

    const textWidth = ctx.measureText(watermarkText).width;
    const textHeight = parseInt(ctx.font); // 假设水印高度与字体大小相同

    // debugger;

     // 计算水印的铺满次数
     const cols = Math.ceil(canvas.width / textWidth);
     const rows = Math.ceil(canvas.height / (textHeight*3));

     console.log(cols, rows, "cols -- rows")
     // 添加水印到 Canvas
     for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        const x = col * textWidth*1.8;
        const y = row * textHeight*5;
        // debugger;
        ctx.fillText(watermarkText, x, y);
      }
    }

     // 将 Canvas 转换为图片并下载
     const imageURI = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
     const link = document.createElement('a');
     link.href = imageURI;
     link.download = title + '.png';
     link.click();
  };

  img.src = imageUrl;
}



// pdf-download
// import pdf from "vue-pdf";
import { degrees, PDFDocument, rgb } from "pdf-lib";
import waterImage from '@/assets/images/watermark.png'; // 替换为你的水印图片路径
async function downPDFFile(fileUrl, fileName) {
  const existingPdfBytes = await fetch(fileUrl).then(res => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const pages = pdfDoc.getPages();

  // debugger;

   // 加载并嵌入水印图片
  const pngImageBytes = await fetch(waterImage).then(res => res.arrayBuffer());
  const pngImage = await pdfDoc.embedPng(pngImageBytes);
  const pngDims = pngImage.scale(0.2); // 调整图片的缩放比例
  // 水印位置，使其位于页眉
  const marginTop = 20; // 页眉的上边距
  const marginLeft = 20; // 水平居中对齐


  // debugger;
  for (let i = 0; i < pages.length; i++) {
    const noPage = pages[i];
    const { width, height } = noPage.getSize();
    for (let i = 0; i < 7; i++) {
      for (let j = 0; j < 4; j++) {
        // 页眉水印图片
        noPage.drawImage(pngImage, {
          x: marginLeft,
          y: height-pngDims.height-marginTop*2,
          width: 32,
          height: 32,
        })

        noPage.drawText("www.coalgeocloud.com", {
          x: 320 * j,
          y: (height / 5) * i,
          size: 20,
          color: rgb(0.46, 0.53, 0.6),
          rotate: degrees(25),
          opacity: 0.3,
        });
      }
    }
  }
  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: 'application/pdf' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName + '.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}



export {watermark, downloadImage, downPDFFile}





// WEBPACK FOOTER //
// ./src/utils/watermark.js